import React from 'react';
import './Home.css';

import HeroBanner from '../../components/HeroBanner'
import ContentList from '../../components/ContentList'
import bkgd1 from './images/bkgd1.jpeg'
import bkgd2 from './images/bkgd2.jpeg'
import bkgd3 from './images/bkgd3.jpeg'

const Home = ({config}) => {
  console.log(config)
  return (
    <div className="home">
      
      <HeroBanner
         heading={config.banner.heading}
         subheading={config.banner.subheading}
         actionText={config.banner.actionText}
         backgroundImage={bkgd1}
         phone={config.banner.phone}
      />

      <ContentList contentData={config.content.slice(0, 1)}/>
      
      <HeroBanner
         backgroundImage={bkgd2}
      />

      <ContentList contentData={config.content.slice(1, 2)}/>
      
      <HeroBanner
         backgroundImage={bkgd3}
      />

      <ContentList contentData={config.content.slice(2)}/>

    </div>
  );
};

export default Home;
